export var settings = {
	global: {
		hideUnneededButtons: true, //true = Unneeded buttons will be hide; false = Unneeded buttons will be showed but disabled
		fieldsCheckOnButtons: true, //true = Buttons will be enabled only when user can press it; false = Buttons always enabled, and check will be done in a function called on buttons click event
		showFieldsPlaceholder: true, //true = Show an information message on field when empty; false = Doesn't show an information message on field when empty
		printerManagement: true, //true = If application manage a printer; false = If application doesn't manage a printer
		nextFieldOnComboSelect: true, //true = If selection of a multiselect value do a goto next field; false = If selection doesn't anything else
		disposeWaitingDays: 45,	//Number of days to wait before a project row can be disposed
		unrestrictedDispose: true, //true = User can dispose a project row without any restriction; false = Only Admin User can dispose a project row
		adminLikeRole: null, //Role name that is considered as admin-like role. If user has this role, he can dispose a project row without any restriction
		debug: false, //true = Show debug information, false = Doesn't show debug informations
	},
	home: {
		lockPlantAndWarehouse: false,	//true = Plant and warehouse fields will be locked on home page; false = Plant and warehouse fields will be unlocked on home page
	},
	insert: {
		autoSave: false, //true = Automatic save record after insert last field; false = User has to press save button
	},
	insertMultiple: {
		autoSave: false, //true = Automatic save record after insert last field; false = User has to press save button
		barcodeOnlyLocation: false,	//true = Location field can be only filled using a barcode; false = Location field can be filled using a barcode or manually
	},
	insertReceipt: {
		barcodeOnlyLocation: false,	//true = Location field can be only filled using a barcode; false = Location field can be filled using a barcode or manually
		skipToReview: false, //true = After insert last mandatory field, skip directly to review step; false = After insert last mandatory field, go to next field
	},
	insertShipment: {
		skipToReview: false, //true = After insert last mandatory field, skip directly to review step; false = After insert last mandatory field, go to next field
	},
	finalizeReceipt: {
		disableChangeOnProjectRow: false,	//true = If project row is closed, user can't change it; false = If project row is closed, user can change it
	},
	finalizeShipment: {
		disableChangeOnProjectRow: false,	//true = If project row is closed, user can't change it; false = If project row is closed, user can change it
	},
};
